export enum ADLClienteTipo {
    Prospecto = 1,
    Cliente = 2
}
